import 'react-phone-number-input/style.css'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input';
import styles from './style.module.scss';
import { errorMessages } from '../../config/notification';

type Tagged<A, T> = A & { __tag?: T };
type E164Number = Tagged<string, "E164Number">;

interface Props {
    label?: string;
    disabled?: boolean;
    isValid?: boolean;
    isRequired?: boolean;
    showErrorMessage?: boolean;
    phoneNumber: string | undefined;
    setIsValid?: Dispatch<SetStateAction<boolean>>;
    setPhoneNumber: Dispatch<SetStateAction<string | undefined>>;
};

function PhoneNumberInput(props: Props) {
    const [errorMessage, setErrorMessage] = useState('');

    const {
        label,
        disabled,
        phoneNumber,
        showErrorMessage,
        isValid,
        isRequired,
        setIsValid,
        setPhoneNumber,
    } = props;

    useEffect(() => {
        if (!phoneNumber) return
        if (!parsePhoneNumber(phoneNumber)?.isValid) {
            setIsValid && setIsValid(false);
            setErrorMessage(errorMessages.phone);
        } else {
            setIsValid && setIsValid(true);
        }
    }, []);

    const setValue = (value: E164Number) => {
        setPhoneNumber(value);
        let errorMessage = '';
        setErrorMessage('');

        if (!value) {
            setIsValid && setIsValid(true);
            return;
        }

        const phoneNumber = parsePhoneNumber(value);
        if (!phoneNumber?.isValid) {
            errorMessage = errorMessages.phone;
            setIsValid && setIsValid(false);
        } else {
            setIsValid && setIsValid(true);
        }

        setErrorMessage(errorMessage);
    };


    return (
        <div
            data-disabled={disabled}
            className={styles.wrapper}
            data-has-error={Boolean(errorMessage)}
        >
            {label && (<span className={styles.label}>{label} {isRequired && <b>*</b>}</span>)}
            <PhoneInput
                placeholder="Enter phone number"
                value={phoneNumber}
                onChange={setValue}
                className={styles.phone}
                limitMaxLength
                disabled={disabled}
            />
            {showErrorMessage && (<span className={styles.error}>{errorMessage}</span>)}
        </div>
    )
};

export default PhoneNumberInput;
